var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 44,
    viewBox: "0 0 119 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.47904 8H0V35.9993H6.47904V8Z",
    fill: "#1B1A1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7963 8H51.3174V35.9993H57.7963V8Z",
    fill: "#1B1A1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.449 13.1979H118.159V8H97V13.1979H103.438H110.449Z",
    fill: "url(#paint0_linear_4843_38815)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.438 30.7976V24.3186H116.437V19.2793H110.449H103.438H97V35.9984H118.679V30.7976H103.438Z",
    fill: "#1B1A1F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7109 17.7171L90.1107 25.5331V8H83.7109V17.7171Z",
    fill: "#1B1A1F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4346 8V35.9993H70.8341V18.9982L84.7943 35.9993H90.1125V32.8143L69.7939 8H64.4346Z",
    fill: "#1B1A1F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5771 29.5358L38.5949 36.0001H44.6744L44.6273 19.375L38.5771 29.5358Z",
    fill: "#1B1A1F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0118 27.1903L36.9862 23.87L38.5553 21.2401L44.6024 11.0794L44.5937 8H39.2752L28.9528 25.3979L18.4748 8H13.1152V35.9993H19.1947V21.5986L27.3955 35.0797H30.3134L35.0118 27.1903Z",
    fill: "#1B1A1F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4843_38815",
    x1: 97,
    y1: 13,
    x2: 118,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C88E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#ECD16D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE9135"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.1ee3e9e1b798d9884d2a1a5e31618e9a.svg";
export { ForwardRef as ReactComponent };